import { render, staticRenderFns } from "./InsFooter.vue?vue&type=template&id=2ab35a68&scoped=true"
import script from "./InsFooter.vue?vue&type=script&lang=ts"
export * from "./InsFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab35a68",
  null
  
)

export default component.exports